import * as React from "react";
import {
  Avatar,
  Box,
  Button,
  Grid,
  Hidden,
  Stack,
  Typography,
} from "@mui/material";
import { User, Group } from "./users-types";
import AddGroupDialog from "./AddGroupDialog";
import AddUser from "./AddUserDialog";
import { useTranslation } from "react-i18next";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import { useAllGroups, useUsers } from "../../pages/api/api";

/* Responsive component representing the highest part of Profile Page */
export default function ProfileIntroduction(props: {
  name: string | null;
  status: string | null;
  users: User[];
  groups: Group[];
}) {
  const [openGroupDialog, setOpenGroupDialog] = React.useState(false);
  const [openUserDialog, setOpenUserDialog] = React.useState(false);
  const { t } = useTranslation();

  const { users, isLoadingUsers, isErrorUsers } = useUsers();
  const { allGroups, isLoadingAllGroups, isErrorAllGroups } = useAllGroups();

  return (
    <Box>
      {localStorage.getItem("Role") !== "USER" && (
        <Box>
          <AddUser
            users={users.filter((user) => user.status === "INACTIVE")}
            groups={allGroups}
            open={openUserDialog}
            setOpen={setOpenUserDialog}
          />
          <AddGroupDialog
            users={props.users}
            update={false}
            open={openGroupDialog}
            setOpen={setOpenGroupDialog}
          />
        </Box>
      )}
      <Hidden mdDown>
        <Stack direction="column" mb={1}>
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" spacing={2}>
              <Avatar alt="user-avatar" sx={{ width: 100, height: 100 }} />
              <Stack direction="column">
                <Typography variant="h2">{props.name}</Typography>
                <Typography variant="h5">{props.status}</Typography>
              </Stack>
            </Stack>
            {localStorage.getItem("Role") !== "USER" && (
              <Stack spacing={2} direction="row">
                <Button
                  variant="contained"
                  startIcon={<PersonAddAltRoundedIcon />}
                  onClick={() => setOpenUserDialog(true)}
                  sx={{ height: "fit-content" }}
                >
                  {t("New user")}
                </Button>
                <Button
                  variant="contained"
                  startIcon={<GroupAddIcon />}
                  onClick={() => setOpenGroupDialog(true)}
                  sx={{ height: "fit-content" }}
                >
                  {t("New group")}
                </Button>
              </Stack>
            )}
          </Stack>
        </Stack>
      </Hidden>
      <Hidden mdUp>
        <Grid container spacing={1} alignItems="center" justifyContent="center">
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" justifyContent="center">
              <Avatar
                alt="user-avatar"
                sx={{ alignItems: "center", width: 50, height: 50 }}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Stack direction="column">
              <Typography variant="h2" textAlign="center">
                {props.name}
              </Typography>
              <Typography variant="h5" textAlign="center">
                {props.status}
              </Typography>
            </Stack>
          </Grid>
          {localStorage.getItem("Role") !== "USER" && (
            <Grid item xs={12}>
              <Stack
                direction="row"
                spacing={1}
                sx={{ p: 1 }}
                alignItems="center"
                justifyContent="center"
              >
                <Button
                  variant="contained"
                  startIcon={<PersonAddAltRoundedIcon />}
                  onClick={() => setOpenUserDialog(true)}
                >
                  {t("New user")}
                </Button>
                <Button
                  variant="contained"
                  startIcon={<GroupAddIcon />}
                  onClick={() => setOpenGroupDialog(true)}
                >
                  {t("New group")}
                </Button>
              </Stack>
            </Grid>
          )}
        </Grid>
      </Hidden>
    </Box>
  );
}
